// extracted by mini-css-extract-plugin
export default {"limitationSet":"LimitationSet_limitationSet__BQEPM","tags":"LimitationSet_tags__nsmkb","hasError":"LimitationSet_hasError__fPUal","emptySpace":"LimitationSet_emptySpace__3RQCh"};